export const credentials: string[] = [
  "gtest",
  "vivium-pretest",
  "child",
  "schneider-pretest",
  "schneider-posttest",
  "hollister-pretest",
  "hollister-posttest",
  "les-nz-pretest",
  "les-nz-posttest",
  "practitioner-6-10-2012-pretest",
  "practitioner-6-10-2012-posttest",
  "practitioner-3-11-2012-pretest",
  "practitioner-3-11-2012-posttest",
  "wio-22-11-2012-pretest",
  "wio-22-11-2012-posttest",
  "iec-25-11-2012-pretest",
  "iec-25-11-2012-posttest",
  "schmitz-14-12-2012-pretest",
  "schmitz-14-12-2012-posttest",
  "cp16-01-2013-pretest",
  "cp16-01-2013-posttest",
  "bms-hrtest",
  "visique-pretest",
  "visique-posttest",
  "practitioner-23-03-2013-pretest",
  "practitioner-23-03-2013-posttest",
  "nexuseq",
  "spain-practitioner-bilbao-21-04-2013-post",
  "spain-practitioner-bilbao-21-04-2013-pre",
  "ariesgl",
  "bhsusa",
  "acphusa",
  "argentina-test",
  "wurthlac",
  "practitioner-11-05-2013-pretest",
  "practitioner-11-05-2013-posttest",
  "alpineusa",
  "karnak-it",
  "directreal-slo",
  "gts-slo",
  "bmw-it",
  "child",
  "adult",
  "panamaexpo",
  "30aug13-panama",
  "practitioner-05-10-2013-pretest",
  "practitioner-05-10-2013-posttest",
  "practitioner-02-11-2013-pretest",
  "practitioner-02-11-2013-posttest",
  "panama-2013-10-10",
  "ukschool2013",
  "ukschool2013a",
  "ukschool2013b",
  "ukschool2013c",
  "ukschool2013d",
  "ukschool2013e",
  "ukschool2013f",
  "ukschool2013g",
  "ukschool2013h",
  "author101",
  "summit-calderdale-pre",
  "summit-calderdale-post",
  "summit-co-pre",
  "summit-co-post",
  "ukschool2013-post",
  "ukschool2013a-post",
  "ukschool2013b-post",
  "ukschool2013c-post",
  "ukschool2013d-post",
  "ukschool2013e-post",
  "ukschool2013f-post",
  "ukschool2013g-post",
  "ukschool2013h-post",
  "test-anas",
  "free-test",
  "pre-udemy",
  "post-udemy",
  "singapore-19-02-2014",
  "practitioner-08-03-2014-pretest",
  "practitioner-08-03-2014-posttest",
  "1gal-pre",
  "2cal-pre",
  "3amb-pre",
  "4men-pre",
  "1gal-post",
  "2cal-post",
  "3amb-post",
  "4men-post",
  "5bio-pre",
  "5bio-post",
  "6apo-pre",
  "6apo-post",
  "7sev-pre",
  "7sev-post",
  "8vlc-pre",
  "8vlc-post",
  "10bel-pre",
  "10bel-post",
  "9pal-pre",
  "9pal-post",
  "iaa-15-04-pre",
  "iaa-15-04-post",
  "practitioner-26-04-2014-pretest",
  "practitioner-26-04-2014-posttest",
  "cronos-2014-04",
  "cronos-2014-04-post",
  "ca-panama-pre",
  "ca-panama-post",
  "twinpre",
  "twinpost",
  "studyt4spre",
  "studyt4spost",
  "practitioner-04-10-2014-pretest",
  "practitioner-04-10-2014-posttest",
  "practitioner-25-10-2014-pretest",
  "practitioner-25-10-2014-posttest",
  "electrabelpre",
  "electrabelpost",
  "electrabel-pre",
  "electrabel-post",
  "nickfragias",
  "geertpriem",
  "csl-pre",
  "csl-post",
  "rock-pre",
  "rock-post",
  "corporate2015-01-09pre",
  "corporate2015-01-09post",
  "prodigynetwork-pre",
  "prodigynetwork-post",
  "practitioner-28-02-2015-pretest",
  "practitioner-28-02-2015-posttest",
  "marcdecloedtpre",
  "marcdecloedtpost",
  "practitioner-14-03-2015-pretest",
  "practitioner-14-03-2015-posttest",
  "badanie",
  "komatsu",
  "acspre",
  "acspost",
  "charisma0615pre",
  "charisma0615post",
  "corporateclass062015",
  "inspiredstarjunepre",
  "inspiredstarjunepost",
  "darlingii-pre",
  "darlingii-post",
  "saintgobain-pre",
  "saintgobain-post",
  "siemens-pre",
  "siemens-post",
  "siemenspre",
  "siemenspost",
  "corporate2pre",
  "corporate2post",
  "banduccipre",
  "banduccipost",
  "practitioner-14-10-2015-pretest",
  "practitioner-14-10-2015-posttest",
  "charisma9dec",
  "charisma",
  "20150129post",
  "20150129pre",
  "20160205pre",
  "20160205post",
  "ypopretest",
  "ypoposttest",
  "practitioner-14-05-2016-pretest",
  "practitioner-14-05-2016-posttest",
  "20160503pretest",
  "20160503posttest",
  "infotopics20160512pre",
  "infotopics20160512post",
  "20160524pre",
  "20160524post",
  "160623cmpre",
  "160623cmpost",
  "badanie2",
  "20161007-pretest",
  "20161007-posttest",
  "practitioner-20161119-pretest",
  "practitioner-20161119-posttest",
  "quadispre",
  "quadispost",
  "badaniebuw",
  "cmRFmars17pre",
  "cmRFmars17post",
  "practitioner-20170506-pretest",
  "practitioner-20170506-posttest",
  "201705lionelpre",
  "201705lionelpost",
  "nikon-20171006post",
  "nikon-20171006pre",
  "harvard2017pretest",
  "harvard2017posttest",
  "nikonpre",
  "nikonpost",
  "practitioner-20171111-pretest",
  "practitioner-20171111-posttest",
  "practitioner-20180519-pretest",
  "practitioner-20180519-posttest",
  "infotopics180615pre",
  "infotopics180615post",
  "uu180723pre",
  "uu180723post",
  "sthree20180917pre",
  "sthree20180917post",
  "RHIMagnesita",
  "rhimagnesita",
  "RHIMagnesitapost",
  "rhimagnesitapost",
  "2018iatapre",
  "2018iatapost",
  "trifinance181023pre",
  "trifinance181023post",
  "practitioner-20181117-pretest",
  "practitioner-20181117-posttest",
  "prodyna181121pre",
  "prodyna181121post",
  "targit190322pre",
  "targit190322post",
  "practitioner-20190427-pretest",
  "practitioner-20190427-posttest",
  "serkan042019pre",
  "serkan042019post",
  "prac191107pre",
  "prac191107post",
  "cargotecpre",
  "cargotecpost",
  "test-pre",
  "test-post",
  "ali2020janpre",
  "ali2020janpost",
  "arjan",
  "sara2020pre",
  "sara2020post",
  "brightpluspre",
  "brightpluspost",
  "practitioner-20201003-pretest",
  "practitioner-20201003-posttest",
  "elena20210218pre",
  "elena20210218post",
  "sara2021pre",
  "sara2021post",
  "testpassword",
  "bpostpre",
  "bpostpost",
  "metvtest",
  "pro",
  "ken",
  "protest",
  "pro2test",
  "pro2",
  "kentest",
  "practitioner-20211009-pretest",
  "practitioner-20211009-posttest",
  "textronpre",
  "textronpost",
  "serkanpre",
  "serkanpost",
  "cronospre",
  "cronospost",
  "frontexpre",
  "frontexpost",
  "ormitpre",
  "ormitpost",
  "pro3test",
  "pro3",
];
